document.addEventListener('DOMContentLoaded', () => {

  const container = document.querySelector('#events-listing');

  if (!container) return;

  /* =====================================================
   MOBILE FILTER
===================================================== */

const mobileFilterButton =
  container.querySelector('[data-mobile-filter-open]');

const filterPanel =
  container.querySelector('[data-events-filter-panel]');


mobileFilterButton?.addEventListener('click', () => {

  if (!filterPanel) return;

  const isOpen =
    filterPanel.classList.toggle('is-open');

  mobileFilterButton.setAttribute(
    'aria-expanded',
    isOpen ? 'true' : 'false'
  );

});

  /* -----------------------------------------
     ELEMENTS
  ----------------------------------------- */

  const cards = [
    ...container.querySelectorAll('[data-event-card]')
  ];

  const dateButtons = [
    ...container.querySelectorAll('[data-date-filter]')
  ];

  const salonSelect =
    container.querySelector('[data-salon-filter]');

  const offerCheckboxes = [
    ...container.querySelectorAll('[data-offer-filter]')
  ];

  const clearButtons = [
  ...container.querySelectorAll('[data-events-clear]')
  ];

  const countElement =
    container.querySelector('[data-events-count]');

  const emptyElement =
    container.querySelector('[data-events-empty]');

  const locationLabel =
  container.querySelector(
    '[data-events-location-label]'
  );  


  /* -----------------------------------------
     FILTER STATE
  ----------------------------------------- */

  const filters = {

    dateType: 'all',

    month: null,

    exactDate: null,

    salon: 'all',

    offers: []

  };


  /* -----------------------------------------
     DATE HELPERS
  ----------------------------------------- */

  function getToday() {

    const today = new Date();

    today.setHours(0, 0, 0, 0);

    return today;

  }


  function parseEventDate(dateString) {

    if (!dateString) return null;

    const date = new Date(
      `${dateString}T00:00:00`
    );

    return Number.isNaN(date.getTime())
      ? null
      : date;

  }


  /* -----------------------------------------
     DATE MATCH
  ----------------------------------------- */

  function matchesDate(card) {

    const dateString =
      card.dataset.eventDate;

    const eventDate =
      parseEventDate(dateString);

    if (!eventDate) {
      return false;
    }


    const today = getToday();


    /*
     ALL DATES

     I recommend still hiding past events
     from the upcoming events section.
    */

    if (filters.dateType === 'all') {

      return eventDate >= today;

    }


    /*
     NEXT 30 DAYS
    */

    if (filters.dateType === 'next-30') {

      const endDate = new Date(today);

      endDate.setDate(
        endDate.getDate() + 30
      );

      return (
        eventDate >= today &&
        eventDate <= endDate
      );

    }


    /*
     MONTH
    */

    if (filters.dateType === 'month') {

      return (
        card.dataset.eventMonth ===
        filters.month
      );

    }


    /*
     EXACT CALENDAR DATE
    */

    if (filters.dateType === 'date') {

      return (
        dateString === filters.exactDate
      );

    }


    return true;

  }


  /* -----------------------------------------
     SALON MATCH
  ----------------------------------------- */

  function matchesSalon(card) {

    if (filters.salon === 'all') {
      return true;
    }

    return (
      card.dataset.eventSalon ===
      filters.salon
    );

  }

/* =====================================================
   SALON MODAL
===================================================== */

const salonModal =
  container.querySelector('[data-salon-modal]');

const salonOpenButton =
  container.querySelector('[data-salon-modal-open]');

const salonCloseButtons = [
  ...container.querySelectorAll('[data-salon-modal-close]')
];

const salonOptions = [
  ...container.querySelectorAll('[data-salon-option]')
];

const salonSelectedText =
  container.querySelector('[data-salon-selected]');


function openSalonModal() {

  if (!salonModal) return;

  salonModal.classList.add('is-open');

  salonModal.setAttribute(
    'aria-hidden',
    'false'
  );

  document.body.classList.add(
    'events-salon-modal-open'
  );

}


function closeSalonModal() {

  if (!salonModal) return;

  salonModal.classList.remove('is-open');

  salonModal.setAttribute(
    'aria-hidden',
    'true'
  );

  document.body.classList.remove(
    'events-salon-modal-open'
  );

}


salonOpenButton?.addEventListener(
  'click',
  openSalonModal
);


salonCloseButtons.forEach(function(button) {

  button.addEventListener(
    'click',
    closeSalonModal
  );

});

salonOptions.forEach(function(option) {

  option.addEventListener('click', function() {

    const salonValue =
      option.dataset.salonOption;

    const salonName =
      option.dataset.salonName;


    /* Update filter */

    filters.salon = salonValue;


    /* Update selected salon text */

    if (salonSelectedText) {
      salonSelectedText.textContent =
        salonName;
    }


    /* Selected state */

    salonOptions.forEach(function(item) {

      item.classList.toggle(
        'is-selected',
        item === option
      );

    });


    /* Update results */

    updateLocationLabel();

    applyFilters();


    /* Close popup */

    closeSalonModal();

  });

});
  /* -----------------------------------------
     OFFER MATCH
  ----------------------------------------- */

  function matchesOffers(card) {

    if (!filters.offers.length) {
      return true;
    }


    /*
     OR behaviour within the offers group.

     If user selects:

     Discount
     Gift

     cards with EITHER offer are shown.
    */

    return filters.offers.some(
      offer => {

        switch (offer) {

          case 'discount':

            return (
              card.dataset.offerDiscount ===
              'true'
            );


          case 'gift':

            return (
              card.dataset.offerGift ===
              'true'
            );


          case 'treatment':

            return (
              card.dataset.offerTreatment ===
              'true'
            );


          default:

            return false;

        }

      }
    );

  }


  /* -----------------------------------------
     APPLY FILTERS
  ----------------------------------------- */

  function applyFilters() {

    let visibleCount = 0;


    cards.forEach(card => {

      const show =
        matchesDate(card) &&
        matchesSalon(card) &&
        matchesOffers(card);


      card.hidden = !show;


      if (show) {
        visibleCount++;
      }

    });


    /* Count */

    if (countElement) {

      countElement.textContent =
        visibleCount;

    }


    /* Empty state */

    if (emptyElement) {

      emptyElement.hidden =
        visibleCount !== 0;

    }

  }

  function updateLocationLabel() {

  if (!locationLabel) return;


  if (filters.salon === 'all') {

    locationLabel.textContent =
      'Across 33 Queensland salons';

    return;
  }


  const selectedOption =
    salonOptions.find(function(option) {

      return (
        option.dataset.salonOption ===
        filters.salon
      );

    });


  if (selectedOption) {

    locationLabel.textContent =
      `Showing ${selectedOption.dataset.salonName}`;

  }

}


  /* -----------------------------------------
     DATE BUTTONS
  ----------------------------------------- */

  dateButtons.forEach(button => {

    button.addEventListener(
      'click',
      () => {

        dateButtons.forEach(btn => {

          btn.classList.remove(
            'is-active'
          );

        });


        button.classList.add(
          'is-active'
        );


        filters.dateType =
          button.dataset.dateFilter;


        if (
          filters.dateType ===
          'month'
        ) {

          filters.month =
            button.dataset.month;

        } else {

          filters.month = null;

        }


        filters.exactDate = null;


        /*
         Remove selected calendar
         date style.
        */

        container
          .querySelectorAll(
            '[data-calendar-date]'
          )
          .forEach(day => {

            day.classList.remove(
              'is-selected'
            );

          });


        applyFilters();

      }
    );

  });


  /* -----------------------------------------
     SALON
  ----------------------------------------- */

  salonSelect?.addEventListener(
  'change',
  event => {

    filters.salon =
      event.target.value;

    updateLocationLabel();

    applyFilters();

  }
);


  /* -----------------------------------------
     OFFERS
  ----------------------------------------- */

  offerCheckboxes.forEach(
    checkbox => {

      checkbox.addEventListener(
        'change',
        () => {

          filters.offers =
            offerCheckboxes
              .filter(input =>
                input.checked
              )
              .map(input =>
                input.value
              );


          applyFilters();

        }
      );

    }
  );

/* =====================================================
   EVENTS CALENDAR
===================================================== */

const calendar = container.querySelector('[data-events-calendar]');
const calendarTitle = container.querySelector('[data-calendar-title]');
const calendarDays = container.querySelector('[data-calendar-days]');
const calendarPrev = container.querySelector('[data-calendar-prev]');
const calendarNext = container.querySelector('[data-calendar-next]');


if (calendar && calendarDays) {

  /* Get all event dates from cards */

  const eventDates = new Set(
    cards
      .map(card => card.dataset.eventDate)
      .filter(Boolean)
  );


  /* Start calendar on first upcoming event */

  const today = getToday();

  const upcomingDates = [...eventDates]
    .map(date => parseEventDate(date))
    .filter(date => date && date >= today)
    .sort((a, b) => a - b);


  let calendarDate =
    upcomingDates.length
      ? new Date(upcomingDates[0])
      : new Date(today);


  calendarDate.setDate(1);


  function formatDateKey(year, month, day) {

    return [
      year,
      String(month + 1).padStart(2, '0'),
      String(day).padStart(2, '0')
    ].join('-');

  }


  function renderCalendar() {

    const year = calendarDate.getFullYear();
    const month = calendarDate.getMonth();


    /* -----------------------------------------
       TITLE
    ----------------------------------------- */

    calendarTitle.textContent =
      new Intl.DateTimeFormat('en-AU', {
        month: 'long',
        year: 'numeric'
      }).format(calendarDate);


    /* -----------------------------------------
       MONTH INFORMATION
    ----------------------------------------- */

    const firstDay =
      new Date(year, month, 1);

    const daysInMonth =
      new Date(year, month + 1, 0).getDate();


    /*
     JavaScript:
     Sunday = 0
     Monday = 1

     Our calendar:
     Monday = first column
    */

    let startingDay =
      firstDay.getDay();

    startingDay =
      startingDay === 0
        ? 6
        : startingDay - 1;


    calendarDays.innerHTML = '';


    /* -----------------------------------------
       EMPTY CELLS BEFORE DAY 1
    ----------------------------------------- */

    for (let i = 0; i < startingDay; i++) {

      const empty =
        document.createElement('span');

      empty.className =
        'events-calendar__empty';

      calendarDays.appendChild(empty);

    }


    /* -----------------------------------------
       DAYS
    ----------------------------------------- */

    for (
      let day = 1;
      day <= daysInMonth;
      day++
    ) {

      const dateKey =
        formatDateKey(
          year,
          month,
          day
        );


      const hasEvent =
        eventDates.has(dateKey);


      const button =
        document.createElement('button');


      button.type = 'button';

      button.className =
        'events-calendar__day';

      button.textContent = day;


      /*
       Full date used by our event filters.
      */

      button.dataset.calendarDate =
        dateKey;


      /*
       Pink background only when
       an event exists.
      */

      if (hasEvent) {

        button.classList.add(
          'has-event'
        );

      }


      /*
       Keep selected date highlighted
       after calendar re-render.
      */

      if (
        filters.dateType === 'date' &&
        filters.exactDate === dateKey
      ) {

        button.classList.add(
          'is-selected'
        );

      }


      /*
       Disable dates without events.

       They still appear in calendar
       but can't be selected.
      */

      if (!hasEvent) {

        button.disabled = true;

      }


      calendarDays.appendChild(
        button
      );

    }

  }


  /* -----------------------------------------
     PREVIOUS MONTH
  ----------------------------------------- */

  calendarPrev?.addEventListener(
    'click',
    () => {

      calendarDate.setMonth(
        calendarDate.getMonth() - 1
      );

      renderCalendar();

    }
  );


  /* -----------------------------------------
     NEXT MONTH
  ----------------------------------------- */

  calendarNext?.addEventListener(
    'click',
    () => {

      calendarDate.setMonth(
        calendarDate.getMonth() + 1
      );

      renderCalendar();

    }
  );


  renderCalendar();

}


  /* -----------------------------------------
     CALENDAR DATES
  ----------------------------------------- */

  container.addEventListener(
    'click',
    event => {

      const day = event.target.closest(
        '[data-calendar-date]'
      );

      if (!day) return;


      const date =
        day.dataset.calendarDate;


      /*
       Clear date pills active state.
      */

      dateButtons.forEach(button => {

        button.classList.remove(
          'is-active'
        );

      });


      /*
       Clear previous calendar day.
      */

      container
        .querySelectorAll(
          '[data-calendar-date]'
        )
        .forEach(calendarDay => {

          calendarDay.classList.remove(
            'is-selected'
          );

        });


      day.classList.add(
        'is-selected'
      );


      filters.dateType = 'date';

      filters.exactDate = date;

      filters.month = null;


      applyFilters();

    }
  );


  /* -----------------------------------------
   CLEAR ALL FILTERS
----------------------------------------- */

function clearAllFilters() {

  /* Reset filter state */

  filters.dateType = 'all';
  filters.month = null;
  filters.exactDate = null;
  filters.salon = 'all';
  filters.offers = [];


  /* Reset date buttons */

  dateButtons.forEach(button => {

    button.classList.toggle(
      'is-active',
      button.dataset.dateFilter === 'all'
    );

  });


  /* Reset salon */

  if (salonSelect) {
    salonSelect.value = 'all';
  }
  
  /* Reset location heading */

updateLocationLabel();

  /* Reset offers */

  offerCheckboxes.forEach(checkbox => {
    checkbox.checked = false;
  });


  /* Reset calendar selection */

  container
    .querySelectorAll('[data-calendar-date]')
    .forEach(day => {
      day.classList.remove('is-selected');
    });


  /* Apply reset filters */
updateLocationLabel();
  applyFilters();

}


/* Both Clear buttons */

clearButtons.forEach(button => {

  button.addEventListener(
    'click',
    clearAllFilters
  );

});


  /* -----------------------------------------
     INITIALIZE
  ----------------------------------------- */

  applyFilters();

});

 /* =====================================================
   KLAVIYO POP-UP
===================================================== */

	document.querySelector('.events-cta__button').addEventListener('click', function (){
		window._klOnsite = window._klOnsite || []; 
		window._klOnsite.push(['openForm', 'UYzijk']);
	});

  